import { api } from "../../gateways/unilabApi";

export async function getByGeomGUIDAndSide(payload) {
  var guid = payload.guid;
  var side = payload.side;
  return await api.get(`factors/getByGeomGUIDAndSide?geomGUID=${guid}&side=${side}`);
}
export async function saveFactors(payload) {
  return await api.post(`factors/save`, payload);
}
